<template>
  <div v-if="visible">
    <div ref="self" class="modal fade show fxConfirm" tabindex="-1" aria-modal="true" role="dialog"
      style="display: block; background: #00000050">
      <div class="modal-dialog modal-dialog-centered mobile:!w-full mobile:!right-0 mobile:!px-3 tablet:px-0 tablet:!w-[450px] !absolute tablet:!right-4 !top-0 !m-0 h-full">
        <div class="modal-content">
          <div class="modal-body">
            <ConfirmLayout :title="title" :image="image" :button-text="buttonText" :closable="hideCloseBtn != 1"
              @close="hide" @confirm="confirm">
              <span v-if="message.length <= 0">{{ text }}</span>
              <span v-else v-html="message" />
            </ConfirmLayout>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import EventBus from "@/plugins/EventBus";
import ConfirmLayout from "./ConfirmLayout.vue";
import { disableScroll, enableScroll } from "../../helpers/scrollHelper";
export default {
  components: { ConfirmLayout },
  props: ['confirmButtonText'],

  data() {
    return {
      visible: false,
      title: "",
      text: "",
      image: null,
      onConfirm: {},
      buttonText: 'Continue',
      isShowConfirmText: false,
      hideCloseBtn: 0,
      message: '' // ✅ added correctly
    };
  },

  mounted() {
    this.onShow = (params) => this.show(params);
    EventBus.on("confirmDialogShow", this.onShow);
  },

  // a layout that re-mounts must not leave its old dialog listening: it opened a second time (scroll jumped to the top)
  beforeUnmount() {
    EventBus.off("confirmDialogShow", this.onShow);
  },

  methods: {
    hide() {
      // a modal still open under this confirm keeps the page locked ($el is not the modal: comment / v-if root)
      const modalBelow = [...document.querySelectorAll('.modal.show')].some(m => m !== this.$refs.self);
      this.visible = false;
      if (modalBelow) return;
      document.documentElement.style.overflow = ''; // Reset HTML element
      document.documentElement.style.paddingRight = '0px';
      enableScroll()
    },
    confirm() {
      // a fast double click lands before the dialog is removed: run the callback once
      if (!this.visible) return;
      // we must check if this.onConfirm is function
      if (typeof this.onConfirm === "function") {
        // run passed function and then close the modal
        this.onConfirm();
        this.hide();
      } else {
        // we only close the modal
        this.hide();
      }
    },
    show(params) {
      // making modal visible
      this.visible = true;
      // setting title and text
      this.title = params.title;
      this.text = params.text;
      this.image = params.image;
      this.isShowConfirmText = params.isShowConfirmText
      // setting callback function
      this.onConfirm = params.onConfirm;
      this.message = params.message ?? ''
      this.buttonText = params.buttonText ?? 'Continue'
      this.hideCloseBtn = params.hideCloseBtn ?? 0

      if (this.isShowConfirmText) {
        this.buttonText = "Confirm"
      }

      document.documentElement.style.overflow = 'hidden'; // Target HTML element
      disableScroll()
      if (window.innerWidth >= 992) {
        document.documentElement.style.paddingRight = '15px';
      } else {
        document.documentElement.style.paddingRight = '0px';
      }

    },
  },
};
</script>